import React from 'react';
import { Button } from 'react-bootstrap';

import Table from '../../../../../facturotopia/table/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EntidadList = ({ data = [], onEdit, onListChange }) => {

  const handleEdit = (item) => {
    onEdit(item);
  }

  const handleDelete = (item) => {
    onListChange(item);
  }

  return (
    <>
      <Table
        columns={ columns(handleEdit, handleDelete) }
        rowKey={ 'id' }
        data={ data }
      >
      </Table>
    </>
  );
}

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={ handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['far', 'edit'] } />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={ handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'trash'] } />
          </Button>
        </>
      );
    }
  },
  {
    align: 'center',
    key: 'entidad',
    title: 'ID Entidad',
    dataIndex: 'entidad',
  },
  {
    align: 'center',
    key: 'IdContabilidad',
    title: 'ID Contabilidad',
    dataIndex: 'IdContabilidad',
  }
];

export default EntidadList;